export const datasetAccessConditions = [
  { label: 'Open Access', value: 'OPEN' },
  { label: 'Mediated Access', value: 'MEDIATED' },
]
